<template>
  <section class="hero is-danger is-bold">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          We're working on this page!
        </h1>
        <h2 class="subtitle">
          This page still isn't completed.<br>
          Probably never will at this point, sorry.
        </h2>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PageNotReady'
}
</script>

<style scoped>
.hero {
  margin: 0 0 20px;
}
</style>
